import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../Util';

const ExplainerText = ({
  align,
  children,
  className,
  size
}) => {
  return (
    <div className={formatClassName(['explainer-text', `${size}-explainer-text`, `${align}-explainer-text`, className])}>
      {children}
    </div>
  );
};

ExplainerText.propTypes = {
  align: PropTypes.oneOf(['center', 'justify', 'left', 'right']),
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['default', 'large'])
};

ExplainerText.defaultProps = {
  align: 'left',
  size: 'default'
};

export default ExplainerText;
